// src/pages/Cookies.tsx
const Cookies = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1614332287897-cdc485fa562d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')" }}
        ></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="hero-content max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Piškotki</h1>
            <p className="text-xl">Informacije o uporabi piškotkov na naši spletni strani</p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-xl shadow-xl p-8 border border-gray-100 card-glow">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl font-bold mb-6">Politika piškotkov</h2>

              <div className="space-y-6 text-gray-700">
                <p>
                  Piškotki so majhne besedilne datoteke, ki se ob obisku spletne strani shranijo na vašo napravo. Na naši spletni strani uporabljamo piškotke za izboljšanje uporabniške izkušnje, analizo prometa in prilagajanje vsebine.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">1. Vrste piškotkov, ki jih uporabljamo</h3>
                <p>
                  Na naši spletni strani uporabljamo naslednje vrste piškotkov:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Nujno potrebni piškotki:</strong> Ti piškotki so potrebni za delovanje naše spletne strani in jih ni mogoče izklopiti.</li>
                  <li><strong>Funkcionalni piškotki:</strong> Ti piškotki omogočajo napredne funkcionalnosti in personalizacijo.</li>
                  <li><strong>Analitični piškotki:</strong> Ti piškotki nam pomagajo razumeti, kako obiskovalci uporabljajo našo spletno stran.</li>
                </ul>

                <h3 className="text-xl font-semibold mt-8 mb-3">2. Kako upravljati piškotke</h3>
                <p>
                  Večina spletnih brskalnikov vam omogoča nadzor nad piškotki prek nastavitev. Piškotke lahko blokirate ali odstranite, vendar lahko to vpliva na vašo uporabniško izkušnjo in nekatere funkcije morda ne bodo delovale pravilno.
                </p>
                <p>
                  Tukaj so povezave do navodil za upravljanje piškotkov v najpogostejših brskalnikih:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-autoBlue hover:underline">Google Chrome</a></li>
                  <li><a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-autoBlue hover:underline">Mozilla Firefox</a></li>
                  <li><a href="https://support.apple.com/sl-si/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-autoBlue hover:underline">Safari</a></li>
                  <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-autoBlue hover:underline">Microsoft Edge</a></li>
                </ul>

                <h3 className="text-xl font-semibold mt-8 mb-3">3. Spremembe politike piškotkov</h3>
                <p>
                  Občasno lahko posodobimo to politiko piškotkov. Spremembe bodo objavljene na tej strani, zato vam priporočamo, da redno preverjate morebitne posodobitve.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">4. Kontaktne informacije</h3>
                <p>
                  Če imate kakršna koli vprašanja o naši politiki piškotkov, nas prosimo kontaktirajte:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg my-4">
                  <p><strong>Avtoservis Vodnik</strong></p>
                  <p>Bukovec 10A, 2314 Zgornja Polskava</p>
                  <p>Email: milan_acko@t-2.net</p>
                  <p>Telefon: 041 273 738</p>
                </div>

                <p>
                  Zadnja posodobitev: {new Date().toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cookies;